import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./pages/Layout";
import "./App.css";
import Dashboard from "./pages/dashboard/Dashboard";
import Support from "./pages/support/Support";
import News from "./pages/news/News";
import Help from "./pages/Help";
import TicketView from "./pages/support/TicketView";
import CreateTicket from "./pages/support/CreateTicket";
import ProductDetail from "./pages/myOrders/ProductDetail";
import Login from "./pages/authentication/Login";
import OTP from "./pages/authentication/OTP";
// import Duepayment from "./pages/Duepayment";
import ProductsInquiry from "./pages/inquiry/ProductsInquiry";
// import Invoice from "./pages/Invoice";
import UserProfile from "./pages/UserProfile";
import Products from "./pages/myOrders/Products";
import Review from "./pages/Review";
import { ToastContainer } from "react-toastify";
import SessionExpire from "./pages/main/SessionExpire";
import { PrivateRoute } from "./utils/PrivateRoute";
// import OTPVarify from "./pages/main/OTPVarify";
import PageNotFound from "./pages/main/PageNotFound";
// import ForgotCustomerID from "./pages/main/ForgotCustomerID";
import InquiryForm from "./pages/main/InquiryForm";
// import RegistrationForm from "./pages/main/RegistrationForm";
import ProductServiceCard from "./pages/main/ProductServiceCard";
import OtherReminder from "./pages/OtherReminder";
import { encryptValue, setIdentityData } from "./utils/Common";
import { useDispatch, useSelector } from "react-redux";
import { handleScreenWidth } from "./redux/reducers/layout";

function App() {

  const dispatch = useDispatch();

  useEffect(() => {
    setIdentityData();
  }, []);

  const screenWidth = useSelector((state) => state.layout.currentScreenWidth);
  useEffect(() => {
    window.addEventListener("resize", () => { dispatch(handleScreenWidth(window.innerWidth)) });
    return () => {
      window.removeEventListener("resize", () => { dispatch(handleScreenWidth(window.innerWidth)) });
    };
  }, [screenWidth, dispatch]);

  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path={"/otp"} element={<OTP />} />
          {/* <Route path="/forgot-cutomerID" element={<ForgotCustomerID />} /> */}
          {/* <Route path="/otpvarify" element={<OTPVarify />} /> */}
          <Route path="/session-expire" element={<SessionExpire />} />

          <Route path="/product-Page" element={<ProductServiceCard />} />
          {/* 
          <Route path="/inquiry-form" element={<InquiryForm />} /> */}
          {/* <Route path="/registration" element={<RegistrationForm />} /> */}
          <Route path="*" element={<PageNotFound />} />

          <Route path="/" element={<Layout />}>
            <Route path="/dashboard" element={<PrivateRoute children={<Dashboard />} />} />
            <Route path="/support" element={<PrivateRoute children={<Support />} />} />
            <Route path="/support/ticket-view" element={<PrivateRoute children={<TicketView />} />} />

            <Route path="/other-reminder" element={<PrivateRoute children={<OtherReminder />} />} />
            <Route path="/news" element={<PrivateRoute children={<News />} />} />
            <Route path="/help" element={<PrivateRoute children={<Help />} />} />

            <Route path="/create-ticket" element={<PrivateRoute children={<CreateTicket />} />} />
            <Route path="/dashboard/product-detail" element={<PrivateRoute children={<ProductDetail />} />} />
            <Route path="/products/product-detail" element={<PrivateRoute children={<ProductDetail />} />} />
            {/* <Route
              path="/due-payment"
              element={<PrivateRoute children={<Duepayment />} />}
            /> */}
            <Route path="/product-inquiry" element={<PrivateRoute children={<ProductsInquiry />} />} />
            <Route path="/product-inquiry/ticket-view" element={<PrivateRoute children={<TicketView />} />} />
            {/* <Route
              path="/invoice"
              element={<PrivateRoute children={<Invoice />} />}
            /> */}
            <Route path="/products" element={<PrivateRoute children={<Products />} />} />
            <Route path="/user-profile" element={<PrivateRoute children={<UserProfile />} />} />
            <Route path="/review" element={<PrivateRoute children={<Review />} />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ToastContainer />
    </>
  );
}

export default App;
